module.exports = __webpack_public_path__ + "img/sachin_at_work.7e87d0f3.jpg";